/**
 * Offline Handler
 * @namespace Ketterer
 * @author    Marc Görtz <https://marcgoertz.de/>
 */

const connectionStatus = {
	offline: 'offline',
	online: 'online',
};

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		(async () => {
			try {
				const registration = await navigator.serviceWorker.register(
					'/serviceworker.js',
					{scope: '/'},
				);

				registration.addEventListener('updatefound', () => {
					// If updatefound is fired, it means that there's
					// a new service worker being installed.
					const installingWorker = registration.installing;
					console.info('⏳ installing');

					if (installingWorker) {
						// You can listen for changes to the installing service worker's
						// state via installingWorker.onstatechange
						installingWorker.addEventListener(
							'statechange',
							(event) => {
								const {state} = event.currentTarget;
								console.info(`✅ ${state}`);
							},
						);
					}
				});

				if (navigator.serviceWorker.controller) {
					navigator.serviceWorker.controller.postMessage({
						command: 'trimCaches',
					});
				}
			} catch (error) {
				console.error('❌ Registration failed', error);
			}
		})();
	});
}

const updateOnlineStatus = () => {
	const condition = navigator.onLine
		? connectionStatus.online
		: connectionStatus.offline;

	const submitButtons = document.querySelectorAll('[type="submit"]');
	for (const button of submitButtons) {
		if (button) {
			button.disabled = condition === connectionStatus.offline;
		}
	}

	const downloadLinks = document.querySelectorAll('[download]');
	for (const link of downloadLinks) {
		// eslint-disable-next-line unicorn/prefer-toggle-attribute -- ARIA attribute needs to be set to true or removed, not false
		if (condition === connectionStatus.offline) {
			link.setAttribute('aria-disabled', 'true');
		} else {
			link.removeAttribute('aria-disabled');
		}
	}
};

addEventListener(connectionStatus.online, updateOnlineStatus);
addEventListener(connectionStatus.offline, updateOnlineStatus);

const refreshButton = document.querySelector('#refresh');
if (refreshButton) {
	refreshButton.addEventListener('click', () => {
		location.reload();
	});
}
